import React, { useState, useEffect } from "react";
import { FaClock, FaTimes } from "react-icons/fa";
import './TempleStatusPopup.css';

const TempleStatusPopup = ({ templeStatus }) => {
  const [showPopup, setShowPopup] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowPopup(false);
    }, 5000); // Auto-dismiss after 10 seconds

    return () => clearTimeout(timer);
  }, []);

  // Guard clause
  if (!templeStatus?.status || !templeStatus?.upcoming || !showPopup) return null;

  const isOpen = templeStatus.status === "Open";

  return (
    <div className="temple-popup">
      <button
        className="close-popup"
        aria-label="Close popup"
        onClick={() => setShowPopup(false)}
      >
        <FaTimes />
      </button>

      <div className="temple-status">
        <span className={`status-pill ${isOpen ? "open" : "closed"}`}>
          Temple is: {isOpen ? "🟢 Open" : "🔴 Closed"}
        </span>

        <span className="aarti-info">
          <FaClock className="clock-icon" />
          {isOpen ? "Current/Upcoming Aarti: " : "Next Aarti: "}
          <strong>
            {templeStatus.upcoming.time} – {templeStatus.upcoming.label}
          </strong>
        </span>
      </div>
    </div>
  );
};

export default TempleStatusPopup;
